import { Box, Grid, Paper } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { DiligenceProgress } from 'components/shared/DiligenceProgress';

import { DiligenceStore } from 'stores/diligence/DiligenceStore';

type JobSummaryProps = {
  diligenceStore: DiligenceStore;
};

const JobSummary = observer(({ diligenceStore }: JobSummaryProps) => {
  const { categoriesStore } = diligenceStore;

  return (
    <Box>
      <Grid container sx={{ display: 'flex', flexDirection: 'column', marginBottom: '16px' }}>
        {categoriesStore && (
          <Grid item xs={12} sm="auto" marginBottom={{ xs: '24px', sm: 0 }}>
            <Paper>
              <DiligenceProgress
                percentComplete={categoriesStore.percentComplete}
                incomplete={categoriesStore.incompleteCategories.length}
                submitted={categoriesStore.submittedCategories.length}
                sx={{ paddingRight: { sm: '0', md: '24px' }, marginRight: { sm: '-50px', md: '0' } }}
              />
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
});

export { JobSummary };
